<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
	name: 'app',
	components: {
	}
}
</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	// font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-family: 'Open Sans';
	font-size: 12px;
	-webkit-font-smoothing: antialiased;
	// background-color: #efefef;
	color: #212529;
	font-weight: 400;
	overflow-y:hidden;
}
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: 'Source Sans Pro',sans-serif;
}
#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
	height: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

html,body,#app,.el-container{
        /*设置内部填充为0，几个布局元素之间没有间距*/
        padding: 0px;
         /*外部间距也是如此设置*/
        margin: 0px;
        /*统一设置高度为100%*/
        height: 100%;
    }

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.el-dialog__header {
    padding: 20px;
    padding-bottom: 10px;
    background-color: cornflowerblue;
}

.el-dialog__title {
    line-height: 24px;
    font-size: 18px;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue